export const MIN_CUSTOM_SERVICE_RATE = 6
export const MAX_CUSTOM_SERVICE_RATE = 1000
export const COACH_PLATFORM_FEE = 0.2



// WEBPACK FOOTER //
// ./src/store/coach/coach.constants.js